export type PersonaClientConfig = {
  templateId?: string;
  environmentId?: string;
  environment?: "sandbox" | "production";
  isConfigured: boolean;
  mode: "live" | "simulated";
};

export function personaClientConfig(): PersonaClientConfig {
  const templateId = readEnv("VITE_PERSONA_TEMPLATE_ID");
  const environmentId = readEnv("VITE_PERSONA_ENVIRONMENT_ID");
  const environment = readEnv("VITE_PERSONA_ENVIRONMENT") as PersonaClientConfig["environment"] | undefined;
  const hasTemplate = Boolean(templateId && templateId.startsWith("itmpl_"));
  const hasEnvironment = Boolean(
    (environmentId && environmentId.startsWith("env_")) || environment === "sandbox" || environment === "production"
  );
  const isConfigured = hasTemplate && hasEnvironment;

  return {
    templateId,
    environmentId,
    environment,
    isConfigured,
    mode: isConfigured ? "live" : "simulated"
  };
}

function readEnv(key: string): string | undefined {
  const value = import.meta.env[key];
  if (typeof value !== "string" || !value.trim()) return undefined;
  return value.trim();
}

export const BUYER_FUNDING_FLOW_PERSONA_LIMITATION =
  "Persona recorded identity verification evidence for the office review. Veto does not certify the buyer, approve funds, or guarantee instruction accuracy.";
